import { AuthClientConfig, AuthService } from '@auth0/auth0-angular';
import { TranslateService } from '@ngx-translate/core';
import {
  WHFeatureConfigDataService,
  WHI18nDataService,
  WHLayoutConfigService,
  WHLoginDataService,
  WHMetadataDataService,
  WHThemeConfigService,
} from '@workheld/workheld-shared-lib';

export const ENV_SETTINGS_URL = `./assets/environment_settings.json`;
export const AVAILABLE_LANGUAGES = [
  'hu',
  'bg',
  'cs',
  'hr',
  'sl',
  'pt',
  'es',
  'fr',
  'de',
  'en',
];

export type Auth0CacheLocation = 'localstorage' | 'memory';

export interface IEnvironmentSettings {
  PRODUCTION: string;
  API_URL: string;
  STAGE: string;
  MGMT_URL: string;
  FLOW_URL: string;
  CALL_URL: string;
  AUTH0_DOMAIN: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_CACHE_LOCATION: Auth0CacheLocation;
  GOOGLE_MAPS_API_KEY: string;
  INSTRUMENTATION_KEY: string;
}

export interface InitContext {
  translateService: TranslateService;
  loginDataService: WHLoginDataService;
  i18nDataService: WHI18nDataService;
  featureConfigDataService: WHFeatureConfigDataService;
  themeConfigService: WHThemeConfigService;
  layoutConfigService: WHLayoutConfigService;
  metadataDataService: WHMetadataDataService;
  authService?: AuthService;
  authClientConfig: AuthClientConfig;
  clientLoggerConfig: any;
}
